(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-split-benefits-accordion';
  var TOGGLE_SELECTOR = '.oddit-section-split-benefits-accordion__toggle';
  var ROW_SELECTOR = '.oddit-section-split-benefits-accordion__row';
  var PANEL_SELECTOR = '.oddit-section-split-benefits-accordion__panel';
  var PANEL_OPEN_CLASS = 'oddit-section-split-benefits-accordion__panel--open';

  function initSection(section) {
    if (!section || section.dataset.odditAccordionReady === 'true') return;
    section.dataset.odditAccordionReady = 'true';

    // Un-hide panels so expand/collapse can animate; the collapsed state is
    // handled in CSS (grid-template-rows: 0fr) once JS is available.
    section.querySelectorAll(PANEL_SELECTOR).forEach(function (panel) {
      panel.removeAttribute('hidden');
    });

    section.addEventListener('click', function (event) {
      var toggle = event.target.closest(TOGGLE_SELECTOR);
      if (!toggle) {
        // The whole row (icon, title, description) toggles the accordion too.
        var row = event.target.closest(ROW_SELECTOR);
        if (!row || !section.contains(row)) return;
        toggle = row.querySelector(TOGGLE_SELECTOR);
      }
      if (!toggle || !section.contains(toggle)) return;

      var panelId = toggle.getAttribute('aria-controls');
      if (!panelId) return;
      var panel = section.querySelector('#' + CSS.escape(panelId));
      if (!panel) return;

      var isOpen = toggle.getAttribute('aria-expanded') === 'true';

      if (isOpen) return;

      // Single-open: collapse any other open tab so only one panel shows at a time.
      if (!isOpen) {
        section.querySelectorAll(TOGGLE_SELECTOR).forEach(function (other) {
          if (other === toggle || other.getAttribute('aria-expanded') !== 'true') return;
          other.setAttribute('aria-expanded', 'false');
          var otherLabel = other.getAttribute('aria-label') || '';
          if (otherLabel) other.setAttribute('aria-label', otherLabel.replace(/^Collapse /, 'Expand '));
          var otherPanelId = other.getAttribute('aria-controls');
          if (otherPanelId) {
            var otherPanel = section.querySelector('#' + CSS.escape(otherPanelId));
            if (otherPanel) otherPanel.classList.remove(PANEL_OPEN_CLASS);
          }
        });
      }

      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      var label = toggle.getAttribute('aria-label') || '';
      if (label) {
        if (isOpen) {
          toggle.setAttribute('aria-label', label.replace(/^Collapse /, 'Expand '));
        } else {
          toggle.setAttribute('aria-label', label.replace(/^Expand /, 'Collapse '));
        }
      }

      panel.classList.toggle(PANEL_OPEN_CLASS, !isOpen);
    });

    applyStaticHeight(section);
  }

  // Desktop only: lock the section to the height of its tallest single-open
  // state so the frame (and the side image) never change height as tabs open or
  // close. The image cover-fills that fixed height, so there's no gap and no
  // extending (Kael's request on QA: ALY-56).
  function applyStaticHeight(section) {
    var inner = section.querySelector('.oddit-section-split-benefits-accordion__inner');
    var content = section.querySelector('.oddit-section-split-benefits-accordion__content');
    if (!inner || !content) return;

    inner.style.height = '';
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    var panels = section.querySelectorAll(PANEL_SELECTOR);
    if (!panels.length) return;

    // Measure the collapsed height with transitions off so the reads are final,
    // not mid-animation. Then add the tallest panel's natural height.
    section.classList.add('is-measuring');
    var reopen = [];
    panels.forEach(function (p) {
      if (p.classList.contains(PANEL_OPEN_CLASS)) {
        p.classList.remove(PANEL_OPEN_CLASS);
        reopen.push(p);
      }
    });
    void content.offsetHeight;

    var base = content.offsetHeight;
    var maxPanel = 0;
    panels.forEach(function (p) {
      var text = p.querySelector('.oddit-section-split-benefits-accordion__panel-text');
      if (text) maxPanel = Math.max(maxPanel, text.scrollHeight);
    });

    reopen.forEach(function (p) { p.classList.add(PANEL_OPEN_CLASS); });
    void content.offsetHeight;
    section.classList.remove('is-measuring');

    if (base && maxPanel) {
      inner.style.height = Math.ceil(base + maxPanel + 24) + 'px';
    }
  }

  function applyAllStaticHeights() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(applyStaticHeight);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  // Re-measure on resize (debounced) and once web fonts settle, since text
  // height feeds the locked height.
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyAllStaticHeights, 150);
  });
  window.addEventListener('load', applyAllStaticHeights);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(applyAllStaticHeights);
  }
})();
